import React from 'react'
import { Cell, Tabs, Tab } from 'react-mdl'
import './style.css'

export default class Quest extends React.Component {

    state = {
        quests: null,
        act_swap: 0,
        difficulty_swap: 0,
        expansion: true
    }

    constructor(props) {
        super(props);
        let quests = [
            [
                props.data.quests.normal.act_i,
                props.data.quests.normal.act_ii,
                props.data.quests.normal.act_iii,
                props.data.quests.normal.act_iv,
                props.data.quests.normal.act_v
            ],
            [
                props.data.quests.nightmare.act_i,
                props.data.quests.nightmare.act_ii,
                props.data.quests.nightmare.act_iii,
                props.data.quests.nightmare.act_iv,
                props.data.quests.nightmare.act_v
            ],
            [
                props.data.quests.hell.act_i,
                props.data.quests.hell.act_ii,
                props.data.quests.hell.act_iii,
                props.data.quests.hell.act_iv,
                props.data.quests.hell.act_v
            ]
        ];

        this.state = {
            quests: quests,
            expansion: props.data.expansion,
            act_swap: 0,
            difficulty_swap: 0
        };
    }

    getQuests(difficulty_swap, act_swap) {
        let quests = this.state.quests[difficulty_swap][act_swap].quests;
        return <div className="act quest">
            <ul className="quests-details">
                { quests.map((quest, quest_number) => 
                    <li className={`quest difficulty-${difficulty_swap} act-${act_swap + 1} q-${quest_number + 1} completed-${quest.completed}`}>
                        <img src={`${process.env.PUBLIC_URL}/assets/quests/a${act_swap + 1}-${quest_number + 1}${quest.completed ? '-completed' : ''}.png`} role="presentation"/>
                        <span className={`quest-label difficulty-${difficulty_swap} act-${act_swap}`}>{quest.name}</span>
                    </li>
                )}
            </ul>
        </div>
    }

    render() {
        return (
            <Cell className="quest-inner" col={12} tablet={6} phone={4}>
                <h3 className="underlined">Quests</h3>
                <Tabs className="quest-difficulty-tab" activeTab={this.state.difficulty_swap} onChange={(tabId) => this.setState({ difficulty_swap: tabId })}>
                    <Tab className='quests-normal'></Tab>
                    <Tab className='quests-nightmare'></Tab>
                    <Tab className='quests-hell'></Tab>
                </Tabs>
                <Tabs className="quest-act-tab" activeTab={this.state.act_swap} onChange={(tabId) => this.setState({ act_swap: tabId })} ripple>
                    <Tab className={`quests-act-i ${this.state.expansion === true ? 'expansion' : 'classic'}`}>Act I</Tab>
                    <Tab className={`quests-act-ii ${this.state.expansion === true ? 'expansion' : 'classic'}`}>Act II</Tab>
                    <Tab className={`quests-act-iii ${this.state.expansion === true ? 'expansion' : 'classic'}`}>Act III</Tab>
                    <Tab className={`quests-act-iv ${this.state.expansion === true ? 'expansion' : 'classic'}`}>Act IV</Tab>
                    <Tab className={`quests-act-v ${this.state.expansion === true ? 'expansion' : 'classic'}`}>Act V</Tab>
                </Tabs>
                <div className="quests-box">
                    {this.getQuests(this.state.difficulty_swap, this.state.act_swap)}
                </div>
            </Cell>
        );
    }
};



// WEBPACK FOOTER //
// ./src/components/character/quest/index.js